import * as _ from 'underscore';
import * as angular from 'angular';
import { InformationCardsService } from '../../informationCards.service';
import { StateParams, StateService } from '@uirouter/core';
import { IImgFileModel } from '../../../../../app.common/modules/common/directives/models';
import { PopupService } from '../../../../../app.common/modules/common/services/popup.service';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';

interface IInformationCardImage {
    id: string;
    url: string;
}

class ChoiceInformationCardImagesComponent {
    static $inject = ['$scope', '$q', 'informationCardsService', 'popupService', 'notificationService', '$translate'];
    currentImagesId: string[];
    serverImagesId: string[];
    callbackUpdate: () => void;
    uploadedImages: IImgFileModel[] = null;
    images: IInformationCardImage[] = [];
    waiting: boolean = false;
    sortableOptions = {
        /*   update: ( event, ui )=> {
              console.log('sortableOptions update', ui);

          } */
    };

    constructor(
        private $scope: ng.IScope,
        private $q: ng.IQService,
        private informationCardsService: InformationCardsService,
        private popupService: PopupService,
        private notificationService: NotificationService,
        private $translate: angular.translate.ITranslateService
    ) {

        this.$scope.$watch('vm.currentImagesId', (n: any, o: any) => {
            if (n) {
                this.init();
            }
        }, true);

        this.$scope.$watch('vm.images', (n: any, o: any) => {
            if (n) {
                this.updateModel();
            }
        }, true);
    }


    uploadImages = async () => {
        if (!this.uploadedImages) {
            return;
        }

        var failImages = _.reject(this.uploadedImages, this.emptyErrorImage);
        var validImages = _.filter(this.uploadedImages, this.emptyErrorImage);

        if (_.size(validImages) === 0) {
            this.showFail(failImages);
            this.uploadedImages = null;
            return;
        }

        this.notificationService.showWaitingMessage();
        this.waiting = true;

        let promises: angular.IPromise<string>[] = [];
        _.forEach(validImages, (image) => {
            promises.push(this.informationCardsService.uploadImage(image));
        });
        try {
            let imageIDs = await this.$q.all(promises);
            _.forEach(imageIDs, (imageID) => {
                if (imageID) {
                    this.images.push(this.getImageModel(imageID));
                }
            }, 0);
            if (_.size(failImages) === 0) {
                this.notificationService.showSuccessMessage();
            } else {
                this.showFail(failImages);
            }
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }

        this.waiting = false;
        this.uploadedImages = null;
    }

    deleteImage = (image: IInformationCardImage) => {
        this.images = _.reject(this.images, (item) => {
            return item.id === image.id;
        });
        this.deleteNoServerImage(image.id);
    }

    close = () => {
        _.forEach(this.images, (image) => {
            this.deleteNoServerImage(image.id);
        });
    }

    private deleteNoServerImage = async (id: string) => {
        var imageID = id;
        if ((imageID) || _.contains(this.serverImagesId, imageID)) {
            return;
        }
        try {
            await this.informationCardsService.deleteImage(imageID);
        } catch (error) {
            console.warn(error + ' image with id ' + imageID + ' is not removed');
        }

    }

    private emptyErrorImage(image: IImgFileModel) {
        return image.error == null || image.error === '';
    }

    private showFail = (failImages: IImgFileModel[]) => {
        this.notificationService.clearAll();
        if (_.size(failImages) === 0) {
            return;
        }
        var li = '';
        _.forEach(failImages, (image) => {
            li += '<li>' + image.name + '</li>';
        });
        var ul = '<ul class="pl15">' + li + '</ul>';
        this.popupService.alert({
            title: this.$translate.instant('cant_upload_photos') || 'Can\'t upload photos',
            content: `<p>${this.$translate.instant('cant_upload_photos_description')}</p>` + ul
        }).catch(function () { return; });
    }


    private getImageModel = (id: string): IInformationCardImage => {
        return {
            id: id,
            url: this.informationCardsService.getImageUrl(id)
        };
    }

    private updateModel = () => {
        this.currentImagesId = _.pluck(this.images, 'id');
        if (_.isFunction(this.callbackUpdate)) {
            this.callbackUpdate();
        }
    }

    private init = () => {
        this.uploadedImages = null;
        this.images = [];
        this.currentImagesId = this.currentImagesId ? this.currentImagesId : [];
        this.serverImagesId = this.serverImagesId ? this.serverImagesId : [];

        if (_.isArray(this.currentImagesId)) {
            _.forEach(this.currentImagesId, (id) => {
                this.images.push(this.getImageModel(id));
            });
        }
    }
}

angular.module('naut').component('choiceInformationCardImages', {
    template: ['$attrs', function ($attrs: ng.IAttributes) {
        return _.isUndefined($attrs.wizard) ? require('./choice-information-card-images.component.html') : require('./choice-information-card-images.component.html');
    }],
    controller: ChoiceInformationCardImagesComponent,
    controllerAs: 'vm',
    bindings: {
        currentImagesId: '=',
        serverImagesId: '=',
        callbackUpdate: '&?'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/informationCards/components/choiceProductImages/choiceInformationCardImages.component.ts